import 'styles/cov-social/index.scss';

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';

import getCSRFMiddlewareToken from 'utils/csrf';
import {createHistory} from 'utils/store';

import 'utils/ui';  /* load materialize dependencies */

import getStore from 'scripts/frontend/questionnaires/store';

import App from './App';

const rootNode = document.getElementById('root');
const CSRFMiddlewareToken = getCSRFMiddlewareToken(rootNode);

const history = createHistory({basename: '/questionnaires'});
const store = getStore({CSRFMiddlewareToken}, history);

render(
    <Provider store={store}>
        <App history={history} />
    </Provider>,
    rootNode,
);



// WEBPACK FOOTER //
// ./scripts/cov-social/index.js